import Image from '@jy95/material-ui-image';
import React, { FC, useState } from 'react';
import { SkeletonCompat as Skeleton } from 'components/SkeletonCompat/SkeletonCompat';
import { asset } from 'utils/assets';

const myLoading = (): JSX.Element => {
  return <Skeleton variant="rectangular" component="div" width={'100%'} height={'100%'} />;
};

const defaultImageConfig = {
  animationDuration: 300,
  color: 'transparent',
  disableSpinner: true,
};

const defaultBGImageConfig = {
  animationDuration: 300,
  color: 'transparent',
  disableError: true,
  imageStyle: {
    objectFit: 'cover',
  },
  loading: myLoading,
  style: {
    height: '100%',
    paddingTop: 'auto',
  },
};
interface MMLImgProps {
  alt?: string;
  fallbackPath?: string;
  height?: number;
  onErrorFallback?: () => void;
  onSuccess?: () => void;
  src: string;
  title?: string;
  useFallback?: boolean;
  width?: number;
}

export const mmlImgFallbackUrl = '/assets/fallback.png';

const MMLImg: FC<MMLImgProps> = ({
  alt,
  fallbackPath,
  height,
  onErrorFallback,
  onSuccess,
  src,
  title,
  useFallback,
  width,
}) => {
  const [showFallbackImage, setShowFallbackImage] = useState(false);

  const onError = () => {
    if (useFallback) {
      setShowFallbackImage(true);
      onErrorFallback?.();
    }
  };

  const image = {
    src: showFallbackImage || src === undefined ? asset(fallbackPath ?? mmlImgFallbackUrl) : src,
    alt: showFallbackImage ? undefined : alt,
    title: showFallbackImage ? undefined : title,
    onError: onError,
    onLoad: onSuccess,
  };
  if (width && height) {
    return (
      <div style={{ width: width, height: height, margin: 'auto' }}>
        <Image {...image} {...defaultImageConfig} aspectRatio={width / height} />
      </div>
    );
  } else {
    return (
      <div style={{ width: '100%', height: '100%', margin: 'auto' }}>
        <Image {...image} {...defaultBGImageConfig} loading={myLoading()} />
      </div>
    );
  }
};

export default React.memo(MMLImg);
